export default function Addons() {
  return (
    <section id="addons">
      <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">Addons</h2>
      <p className="text-slate-600 dark:text-slate-400 mb-8 leading-relaxed">
        The Addons tab lets you manage behaviour packs and resource packs attached to your world.
        It has two sub-tabs: one for packs already on the world, and one for browsing your globally
        installed Minecraft add-ons. You can also manage global addons without loading a world first
        — click <strong>Manage Addons</strong> on the landing page to browse, import, and remove
        addons from your Minecraft installation.
      </p>

      {/* World Addons */}
      <div id="world-addons" className="mb-8">
        <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">World Addons</h3>
        <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 p-5 space-y-4 text-sm text-slate-600 dark:text-slate-400">
          <p>
            Shows all behaviour packs and resource packs currently linked to your world.
          </p>
          <ul className="space-y-2">
            <li><strong className="text-slate-800 dark:text-slate-200">Import</strong> — Import add-ons from .mcpack, .mcaddon, or .zip files directly into the world. You can select multiple files at once to import them all in one go.</li>
            <li><strong className="text-slate-800 dark:text-slate-200">Remove</strong> — Remove a pack from the world. Removing a pack will also remove any linked dependencies.</li>
            <li>
              <strong className="text-slate-800 dark:text-slate-200">Addon Details</strong> — Select a
              pack to view its details, including whether it is achievement friendly, whether it uses
              beta APIs, and what dependencies it has.
            </li>
            <li>
              <strong className="text-slate-800 dark:text-slate-200">Make Achievement Friendly</strong> — If
              an addon is not achievement friendly, a button is shown to alter the behaviour pack's manifest
              file to attempt to make it work with achievements enabled.
            </li>
          </ul>
          <p>
            All changes made on this tab are staged and won't take effect until you save your world.
          </p>
        </div>
      </div>

      {/* Minecraft Addons */}
      <div id="minecraft-addons" className="mb-8">
        <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">Minecraft Addons</h3>
        <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 p-5 space-y-4 text-sm text-slate-600 dark:text-slate-400">
          <p>
            Browse all add-ons currently installed in Minecraft on your computer. Like the World
            Addons tab, you can import new packs directly into Minecraft or remove existing ones.
          </p>
          <ul className="space-y-2">
            <li>
              <strong className="text-slate-800 dark:text-slate-200">Add to World</strong> — Add any
              installed addon directly to your currently opened world. Any linked dependencies will be
              imported automatically.
            </li>
            <li>
              <strong className="text-slate-800 dark:text-slate-200">Import / Remove</strong> — Import
              new packs into Minecraft or remove existing ones from the Minecraft installation. You
              can select multiple files at once when importing.
            </li>
          </ul>
          <div className="rounded-lg border border-amber-200 dark:border-amber-800/50 bg-amber-50 dark:bg-amber-900/20 p-3">
            <p className="text-amber-700 dark:text-amber-400 text-xs">
              DRM-protected Marketplace addons cannot be added to your world due to licensing
              restrictions.
            </p>
          </div>
          <p>
            All changes on this tab are applied immediately, as they affect the Minecraft
            installation rather than the currently opened world.
          </p>
        </div>
      </div>
    </section>
  );
}
